import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a6a3c74a875aa0014bc909a_1785846279551_d4f49ee9/medicompare/src/app/not-found.tsx");
